import { useEffect, useState } from "react"
import TitleEvaluations from "../../../components/Evaluations/TitleEvaluations"
import { DimensionEvaluation, Subdimensiones } from "../../../interfaces/Evaluations"
import ResponsiveContainer from "../../../layouts/ResponsiveContainer"
import Tabs from "../../../components/Tabs/Tabs"
import EvaluationSubdimensionResAndProc from "./ResAndProc/Subdimension/EvaluationSubdimensionResAndProc"
import { INDICATOR_TYPE_STRUCTURAL } from "../../../utils/const"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { evaluationSubDimension, selectedDimension } from "../../../redux/slices/evaluator/evaluatorSlice"
import EvaluationSubdimensionStructural from "./Structural/Subdimension/EvaluationSubdimensionStructural"
import { MdInfo } from "react-icons/md"
import Dialog from "../../../components/Dialog/Dialog"
import { useNavigate } from "react-router-dom"
import { scrollToElement } from "../../../utils/utils"
import DynamicBannerCard from "../../../components/Cards/DynamicBannerCard"
import DashboardIcon from '../../../assets/icons/dashboard.svg';

interface IEvaluationDimension {
    evaluation_dimension: DimensionEvaluation[],
    evaluation_subDimension_RES_PROC: Subdimensiones[],
    selected_type_indicator: { name: string, id: number },
    right: string,
    rightId: string
}

const EvaluationDimension = ({
    evaluation_dimension,
    evaluation_subDimension_RES_PROC,
    selected_type_indicator,
    right,
    rightId
}: IEvaluationDimension) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false)
    const params = new URLSearchParams(window.location.search);
    const { selected_dimension } = useAppSelector((state) => state.evaluator)

    useEffect(() => {
        if (evaluation_dimension.length > 0) {
            const foundDimension = selected_dimension
                ? evaluation_dimension.find(dim => dim.id === selected_dimension.id)
                : null;

            const idToSelect = foundDimension ? foundDimension.id : evaluation_dimension[0].id;

            setSelectedId(idToSelect);

            const finalDimension = evaluation_dimension.find(dim => dim.id === idToSelect);
            if (finalDimension) {
                dispatch(selectedDimension({ dimension: { name: finalDimension.nombre, id: finalDimension.id } }));
                dispatch(evaluationSubDimension({ dimensionId: finalDimension.id }));
            }
        }
    }, [selected_type_indicator, evaluation_dimension, dispatch]);

    const handleTabClick = (id: number, name?: string) => {
        params.set('dimensionId', id.toString());
        params.set('dimension', name!);
        navigate({ search: params.toString() });

        setSelectedId(id);
        dispatch(selectedDimension({ dimension: { name: name ?? '', id: id } }))
        dispatch(evaluationSubDimension({ dimensionId: id }));
        scrollToElement('subdimensions', -120, 250);
    };

    const closeModal = () => {
        setIsModalVisible(false)
    }

    return (
        <div className='flex justify-center items-center flex-col relative'>
            {selected_type_indicator && selected_type_indicator ? (
                <>
                    <>
                        <div className="w-full sticky top-0 z-[362025] bg-primary-100 md:static mt-10 shadow-custom-dual md:shadow-none md:w-[53.563rem] lg:w-[55rem] xl:w-[70.5rem]">
                            <TitleEvaluations
                                label='Dimensiones'
                                textStyle="text-tmedium md:text-hsmall text-primary-10 mb-4 pl-3 pt-4 pb-2 md:pl-0 border-y border-t-[#DCE4E9] border-b-[#DCE4E9] md:border-none"
                                onClick={() => setIsModalVisible(!isModalVisible)}
                            />
                            <Tabs
                                tabs={evaluation_dimension}
                                selectedIndex={selectedId}
                                onTabClick={handleTabClick}
                            />
                        </div>
                        <div className="h-[6px] md:h-px w-full bg-system-primary-20 md:w-[53.563rem] lg:w-[55rem] xl:w-[70.5rem]"></div>
                    </>
                    <ResponsiveContainer id='subdimensions'>
                        {selected_type_indicator.name === INDICATOR_TYPE_STRUCTURAL
                            ? <EvaluationSubdimensionStructural
                                evaluation_subDimension={evaluation_subDimension_RES_PROC}
                                selected_type_indicator={selected_type_indicator}
                            />
                            : <EvaluationSubdimensionResAndProc
                                selected_type_indicator={selected_type_indicator}
                                evaluation_subDimension={evaluation_subDimension_RES_PROC}
                            />
                        }
                        <DynamicBannerCard
                            title='Metodología de evaluación'
                            text='Conocé los criterios y los pasos que seguimos para realizar la evaluación del derecho y sus dimensiones'
                            icon={DashboardIcon}
                            buttonLabel='Ver'
                            buttonUrl={`/monitor/metodologia?right=${right}&rightId=${rightId}`}
                        />
                    </ResponsiveContainer>
                </>
            ) : null}
            <Dialog
                isOpen={isModalVisible}
                toggle={closeModal}
                bgColor='bg-brand-green-5'
            >
                <div className="flex justify-center mb-2">
                    <MdInfo size={32} color="#205253" />
                </div>
                <h2 className="text-center text-hsmall text-system-light-100 mb-4">Información</h2>
                <p className="text-left font-bold text-bmedium text-brand-green-20">Dimensiones:</p>
                <p className="text-left text-bmedium text-system-light-100">Identifican distintos aspectos del derecho y nos permiten comprender mejor su alcance. Las definimos siguiendo criterios del Comité de Derechos Económicos, Sociales y Culturales de Naciones Unidas.</p>
                <br />
                <p className="text-left font-bold text-bmedium text-brand-green-20">Subdimensiones:</p>
                <p className="text-left text-bmedium text-system-light-100">Desagregan el contenido de las dimensiones para facilitar la lectura y el análisis de la información. Posibilitan un primer agrupamiento de los indicadores que, a su vez, reflejan variables conformadas por datos oficiales. Para saber más sobre las dimensiones y subdimensiones podés acceder a nuestra Metodología de Evaluación.</p>
            </Dialog>
        </div>
    );
}

export default EvaluationDimension